/* Keep native gallery, variants, quantity and cart events. Only connect the new sort control and sticky visibility. */
(() => {
  if (window.legadoCommerceInitialized) return;
  window.legadoCommerceInitialized = true;
  const mobile = window.matchMedia('(max-width: 749px)');
  const observers = new Map();
  let pendingHeaderFrame = false;
  function updateHeaderOffset() {
    pendingHeaderFrame = false;
    if (!mobile.matches) return;
    const header = document.querySelector('.section-header');
    document.documentElement.style.setProperty('--legado-header-offset', `${Math.max(0, header?.getBoundingClientRect().bottom || 0)}px`);
  }
  function onScroll() {
    if (!pendingHeaderFrame) { pendingHeaderFrame = true; requestAnimationFrame(updateHeaderOffset); }
  }
  function syncSort() {
    const control = document.querySelector('.legado-sort-select');
    const native = document.getElementById('SortBy-mobile');
    if (control && native) control.value = native.value;
  }
  function init() {
    updateHeaderOffset();
    syncSort();
    const grid = document.getElementById('ProductGridContainer');
    if (grid && !observers.has(grid)) {
      const observer = new MutationObserver(syncSort);
      observer.observe(grid, { childList: true });
      observers.set(grid, observer);
    }
    const cta = document.querySelector('.legado-product .main-product-form [type="submit"]');
    const sticky = document.querySelector('.legado-product sticky-atc');
    if (cta && sticky && !observers.has(cta)) {
      const observer = new IntersectionObserver(entries => {
        const entry = entries[0];
        sticky.dataset.legadoVisible = String(mobile.matches && !entry.isIntersecting && entry.boundingClientRect.bottom <= 90);
      }, { rootMargin: '-90px 0px 0px 0px', threshold: 0 });
      observer.observe(cta);
      observers.set(cta, observer);
    }
  }
  document.addEventListener('change', event => {
    if (!event.target.matches('.legado-sort-select')) return;
    const native = document.getElementById('SortBy-mobile');
    if (native) {
      native.value = event.target.value;
      native.dispatchEvent(new Event('input', { bubbles: true }));
    } else {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', event.target.value);
      url.searchParams.delete('page');
      window.location.assign(url.href);
    }
  });
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', () => {
    for (const [element, observer] of observers) {
      if (!element.isConnected) { observer.disconnect(); observers.delete(element); }
    }
  });
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  mobile.addEventListener('change', () => {
    const sticky = document.querySelector('.legado-product sticky-atc');
    if (sticky) {
      const cta = document.querySelector('.main-product-form [type="submit"]');
      sticky.dataset.legadoVisible = String(mobile.matches && !!cta && cta.getBoundingClientRect().bottom <= 90);
    }
    updateHeaderOffset();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
